import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SchPayReceiptsUIHelpers";

const SchPayReceiptsUIContext = createContext();

export function useSchPayReceiptsUIContext() {
  return useContext(SchPayReceiptsUIContext);
}

export const SchPayReceiptsUIConsumer = SchPayReceiptsUIContext.Consumer;

export function SchPayReceiptsUIProvider({ schPayReceiptsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    newSchPayReceiptButtonClick: schPayReceiptsUIEvents.newSchPayReceiptButtonClick,
    openEditSchPayReceiptPage: schPayReceiptsUIEvents.openEditSchPayReceiptPage,
    openDeleteSchPayReceiptDialog: schPayReceiptsUIEvents.openDeleteSchPayReceiptDialog,
    openDeleteSchPayReceiptsDialog: schPayReceiptsUIEvents.openDeleteSchPayReceiptsDialog,
    openFetchSchPayReceiptsDialog: schPayReceiptsUIEvents.openFetchSchPayReceiptsDialog,
  };

  return (
    <SchPayReceiptsUIContext.Provider value={value}>
      {children}
    </SchPayReceiptsUIContext.Provider>
  );
}
